import React from "react";
import { AppPage } from "ui/AppPage";

export const NotFoundPage = () => (
  <AppPage>
    <h2>Page not found 💔</h2>
  </AppPage>
);
